let navigate = null;

export const setNavigator = (navFn) => {
  navigate = navFn;
};

export const getNavigator = () => navigate;
